import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';
import './TermsOfServicePage.css';

const TermsOfServicePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="terms-of-service-page">
      <div className="container">
        <div className="policy-header">
          <h1 className="page-title">Terms of Service</h1>
          <p className="page-subtitle">Last updated: March 14, 2025</p>
        </div>
        
        <div className="policy-content">
          <section className="policy-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to Sign in Seconds. These Terms of Service ("Terms") govern your use of our website 
              and e-signature services (collectively, the "Services") operated by Sign in Seconds ("we," "us," or "our").
            </p>
            <p>
              By accessing or using our Services, you agree to be bound by these Terms. If you disagree with 
              any part of the Terms, you may not access the Services.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>2. Accounts</h2>
            <p>
              When you create an account with us, you must provide accurate, complete, and current information. 
              Failure to do so constitutes a breach of the Terms, which may result in immediate termination of 
              your account on our Services.
            </p>
            <p>
              You are responsible for safeguarding the password that you use to access the Services and for any 
              activities or actions under your password. You agree not to disclose your password to any third party. 
              You must notify us immediately upon becoming aware of any breach of security or unauthorized use of 
              your account.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>3. E-Signature Services</h2>
            <p>
              Our Services allow you to electronically sign documents and collect electronic signatures from others. 
              By using our e-signature Services, you agree that:
            </p>
            <ul>
              <li>You will only upload documents that you have the legal right to sign or request signatures for.</li>
              <li>Electronic signatures created through our Services are legally binding, equivalent to handwritten signatures.</li>
              <li>You are responsible for ensuring that the content of your documents complies with all applicable laws.</li>
              <li>We are not responsible for the content of documents processed through our Services.</li>
              <li>We may retain copies of signed documents as required by law or as necessary to provide the Services.</li>
            </ul>
          </section>
          
          <section className="policy-section">
            <h2>4. Intellectual Property</h2>
            <p>
              The Services and their original content, features, and functionality are and will remain the exclusive 
              property of Sign in Seconds and its licensors. The Services are protected by copyright, trademark, and 
              other laws of both the United States and foreign countries. Our trademarks and trade dress may not be 
              used in connection with any product or service without the prior written consent of Sign in Seconds.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>5. User Content</h2>
            <p>
              Our Services allow you to upload, store, send, and share content, including documents for signature 
              ("User Content"). You retain all rights to your User Content. By uploading User Content to our Services, 
              you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, 
              and display such User Content solely for the purpose of providing the Services to you.
            </p>
            <p>
              You represent and warrant that:
            </p>
            <ul>
              <li>You own or have the necessary rights to use and authorize us to use your User Content as described above.</li>
              <li>Your User Content does not violate the privacy rights, publicity rights, copyrights, contract rights, or any other rights of any person or entity.</li>
            </ul>
          </section>
          
          <section className="policy-section">
            <h2>6. Prohibited Uses</h2>
            <p>
              You may use our Services only for lawful purposes and in accordance with these Terms. You agree not to use our Services:
            </p>
            <ul>
              <li>In any way that violates any applicable federal, state, local, or international law or regulation.</li>
              <li>To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail," "chain letter," "spam," or any other similar solicitation.</li>
              <li>To impersonate or attempt to impersonate Sign in Seconds, a Sign in Seconds employee, another user, or any other person or entity.</li>
              <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Services, or which may harm Sign in Seconds or users of the Services.</li>
            </ul>
          </section>
          
          <section className="policy-section">
            <h2>7. Termination</h2>
            <p>
              We may terminate or suspend your account immediately, without prior notice or liability, for any reason 
              whatsoever, including without limitation if you breach the Terms.
            </p>
            <p>
              Upon termination, your right to use the Services will immediately cease. If you wish to terminate your 
              account, you may simply discontinue using the Services or contact us to request account deletion.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>8. Limitation of Liability</h2>
            <p>
              In no event shall Sign in Seconds, nor its directors, employees, partners, agents, suppliers, or affiliates, 
              be liable for any indirect, incidental, special, consequential or punitive damages, including without 
              limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:
            </p>
            <ul>
              <li>Your access to or use of or inability to access or use the Services;</li>
              <li>Any conduct or content of any third party on the Services;</li>
              <li>Any content obtained from the Services; and</li>
              <li>Unauthorized access, use or alteration of your transmissions or content.</li>
            </ul>
          </section>
          
          <section className="policy-section">
            <h2>9. Disclaimer</h2>
            <p>
              Your use of the Services is at your sole risk. The Services are provided on an "AS IS" and "AS AVAILABLE" 
              basis. The Services are provided without warranties of any kind, whether express or implied, including, 
              but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement 
              or course of performance.
            </p>
            <p>
              Sign in Seconds does not warrant that the Services will function uninterrupted, secure or available at any 
              particular time or location, or that any errors or defects will be corrected.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>10. Governing Law</h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of the State of California, 
              United States, without regard to its conflict of law provisions.
            </p>
            <p>
              Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. 
              If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions 
              of these Terms will remain in effect.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>11. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision 
              is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What 
              constitutes a material change will be determined at our sole discretion.
            </p>
            <p>
              By continuing to access or use our Services after those revisions become effective, you agree to be bound 
              by the revised terms. If you do not agree to the new terms, please stop using the Services.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>12. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us:
            </p>
            <ul>
              <li>By email: support@signinseconds.com</li>
              <li>By phone: +1 (555) 123-4567</li>
              <li>By mail: Sign in Seconds, 123 E-Signature Street, San Francisco, CA 94105, USA</li>
            </ul>
          </section>
        </div>
        
        <div className="policy-footer">
          <Link to="/">
            <Button variant="secondary">Back to Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
